import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverHaltsFilterEntity } from '../../domain/entities/DriverHaltsFilterEntity'

export class DriverHaltsFilterModel extends DriverHaltsFilterEntity {
  driverId?: number
  regionId?: number
  constructor(dataDto: DriverHaltsFilterEntity) {
    super()
    mapEntityProperties<DriverHaltsFilterModel>(this, dataDto, {
      exclude: ['driver', 'region'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
